import {IValue} from '@mintdata/mint-kit/api/types/Value';
import {ColumnOffset, FieldName, IFrameRecord, IKeyedMap,} from '@mintdata/mint-kit/api/values/frames/Frame';
import {InvalidColumnOffset, NoSuchField} from '@mintdata/mint-kit/api/values/frames/FrameErrors';

export class AFrameRecord implements IFrameRecord
{
    private _fieldNames:FieldName[];
    private _values:IValue[];
    private _fieldNameToColumnOffset:Map<FieldName, ColumnOffset> = new Map();
    private _fieldNameToColumnOffsetLC:Map<FieldName, ColumnOffset> = new Map();

    constructor(private _keyedObject:IKeyedMap)
    {
        let fieldNames = this._fieldNames = Array.from(this._keyedObject.keys());

        this._values = fieldNames.map((fieldName, columnOffset:ColumnOffset) =>
        {
            this._fieldNameToColumnOffset.set(fieldName, columnOffset);
            this._fieldNameToColumnOffsetLC.set(fieldName.toLowerCase(), columnOffset);

            return this._keyedObject.get(fieldName);
        });
    }

    getFieldNames():Array<FieldName>
    {
        return this._fieldNames.slice();
    }

    getCells():IValue[]
    {
        return this._values.slice();
    }

    hasCell(fieldName:FieldName, isIgnoreCase:boolean = false):boolean
    {
        if( isIgnoreCase )
            return this._fieldNameToColumnOffsetLC.has(fieldName.toLowerCase());
        else
            return this._fieldNameToColumnOffset.has(fieldName);
    }

    getCell(fieldName:FieldName, isIgnoreCase:boolean = false):IValue
    {
        if( !this.hasCell(fieldName, isIgnoreCase) )
            throw new NoSuchField(`Field ${fieldName} does not exist in record`);

        let columnOffset:ColumnOffset;
        if( isIgnoreCase )
            columnOffset = this._fieldNameToColumnOffsetLC.get(fieldName.toLowerCase());
        else
            columnOffset = this._fieldNameToColumnOffset.get(fieldName);

        return this._values[columnOffset];
    }

    getCellAtOffset(columnOffset:ColumnOffset):IValue
    {
        if( columnOffset < 0 || columnOffset > this._values.length )
            throw new InvalidColumnOffset(`${columnOffset} is invalid (column count: ${this._values.length})`);

        return this._values[columnOffset];
    }
}
